import { aspectRatioMapping } from '../../utils/aspect-ratio';
import { generateSrc } from './generate-src';
export const generateSrcSet = (options) => {
    const { maxHeight, minWidth, aspectRatio, interval, url, hasDarkeningLayer, hasImageTransparency, additionalUrlParameters, omitAspectRatioInUrl } = options;
    const numericAspectRatio = aspectRatioMapping[aspectRatio];
    const modifiedInterval = numericAspectRatio < 1 ? interval / 2 : interval;
    let srcSet = '';
    const maxWidth = maxHeight * numericAspectRatio;
    for (let width = minWidth; width <= maxWidth; width += modifiedInterval) {
        const height = Math.round(width / numericAspectRatio);
        srcSet += `${width === minWidth ? '' : ', '}${generateSrc({
            width,
            height,
            url,
            aspectRatio,
            hasDarkeningLayer,
            hasImageTransparency,
            additionalUrlParameters,
            omitAspectRatioInUrl
        })} ${width}w`;
    }
    return srcSet;
};
//# sourceMappingURL=generate-src-set.js.map